import { z } from 'zod';
const theme = (key, name, mode, colors, extra = {}) => {
    const [ground, surface, ink, muted, line, action, on, soft, brand] = colors;
    return {
        key,
        name,
        mode,
        base: { ground, surface, ink, muted, line, action, on, soft, brand },
        dark: extra.dark ?? null,
        font: extra.font ?? null,
        warmBad: extra.warmBad ?? false,
    };
};
export const CLINIC_THEME_FONTS = ['acolhedor', 'classico', 'tecnico', 'leitura'];
export const CLINIC_THEME_FONT_INFO = {
    acolhedor: {
        label: 'Acolhedor',
        display: "'Fredoka', system-ui, sans-serif",
        body: "'Nunito', system-ui, sans-serif",
        numbers: "'Fredoka', system-ui, sans-serif",
    },
    classico: {
        label: 'Clássico',
        display: "'Source Serif 4', Georgia, serif",
        body: "'Source Sans 3', system-ui, sans-serif",
        numbers: "'Source Sans 3', system-ui, sans-serif",
    },
    tecnico: {
        label: 'Técnico',
        display: "'IBM Plex Sans', system-ui, sans-serif",
        body: "'IBM Plex Sans', system-ui, sans-serif",
        numbers: "'IBM Plex Mono', ui-monospace, monospace",
    },
    leitura: {
        label: 'Leitura fácil',
        display: "'Atkinson Hyperlegible', system-ui, sans-serif",
        body: "'Atkinson Hyperlegible', system-ui, sans-serif",
        numbers: "'Atkinson Hyperlegible', system-ui, sans-serif",
    },
};
export const CLINIC_THEMES = [
    theme('sec', 'Sec', 'claro', [
        '#FBF8F5',
        '#FFFFFF',
        '#2C2320',
        '#6F6157',
        '#EBE2D9',
        '#C24E29',
        '#FFFFFF',
        '#FDEEE6',
        '#C24E29',
    ], { dark: 'escuro', font: 'acolhedor' }),
    theme('azul-real', 'Azul real', 'claro', [
        '#F8F3F0',
        '#FFFFFF',
        '#00224C',
        '#5F6C7F',
        '#DADADC',
        '#014BAA',
        '#FFFFFF',
        '#E6EDF6',
        '#014BAA',
    ], { dark: 'escuro-tecnico', font: 'tecnico' }),
    theme('vinho', 'Vinho', 'claro', [
        '#F8F2E0',
        '#FFFFFF',
        '#39000E',
        '#836565',
        '#E1D5C7',
        '#7F011F',
        '#FFFFFF',
        '#F2E6E9',
        '#7F011F',
    ], { dark: 'escuro-fino', font: 'classico', warmBad: true }),
    theme('laranja', 'Laranja', 'claro', [
        '#FDFDF1',
        '#FFFFFF',
        '#58240F',
        '#896D5C',
        '#E9E3D6',
        '#CF4712',
        '#FFFFFF',
        '#FDEFE9',
        '#EC5E27',
    ], { dark: 'escuro', font: 'acolhedor' }),
    theme('ameixa', 'Ameixa', 'claro', [
        '#FFF3E6',
        '#FFFFFF',
        '#2A1326',
        '#7B696D',
        '#E5D8CF',
        '#381932',
        '#FFFFFF',
        '#EBE8EB',
        '#381932',
    ], { dark: 'ameixa-noite', font: 'acolhedor' }),
    theme('indigo', 'Índigo', 'claro', [
        '#F4F2E7',
        '#FFFFFF',
        '#121321',
        '#69686B',
        '#D9D7CF',
        '#282B4A',
        '#FFFFFF',
        '#EAEAED',
        '#282B4A',
    ], { dark: 'indigo-noite', font: 'tecnico' }),
    theme('cereja', 'Cereja', 'claro', [
        '#F3F3E7',
        '#FFFFFF',
        '#3E0021',
        '#836570',
        '#DDD6CF',
        '#890149',
        '#FFFFFF',
        '#F3E6ED',
        '#890149',
    ], { dark: 'escuro-fino', font: 'classico', warmBad: true }),
    theme('floresta', 'Floresta', 'claro', [
        '#F0FFE0',
        '#FFFFFF',
        '#032017',
        '#597258',
        '#C5E4AD',
        '#064734',
        '#FFFFFF',
        '#E0FFC2',
        '#064734',
    ], { dark: 'floresta-noite', font: 'acolhedor' }),
    theme('grafite', 'Grafite', 'claro', [
        '#F4F5F6',
        '#FFFFFF',
        '#1A1C1F',
        '#6D6F71',
        '#DADBDC',
        '#3A3F44',
        '#FFFFFF',
        '#EBECEC',
        '#3A3F44',
    ], { dark: 'escuro-tecnico', font: 'tecnico' }),
    theme('escuro', 'Escuro padrão', 'escuro', [
        '#121212',
        '#202020',
        '#ECECEC',
        '#909090',
        '#313131',
        '#E8825F',
        '#111111',
        '#392620',
        '#E8825F',
    ]),
    theme('escuro-fino', 'Escuro fino', 'escuro', [
        '#1B1816',
        '#292624',
        '#F1EBE3',
        '#97928D',
        '#393633',
        '#D9B98C',
        '#111111',
        '#3D352B',
        '#D9B98C',
    ]),
    theme('escuro-tecnico', 'Escuro técnico', 'escuro', [
        '#0D1117',
        '#1C1F25',
        '#E6EDF3',
        '#8B9197',
        '#2B3036',
        '#4C9EFF',
        '#111111',
        '#182A41',
        '#4C9EFF',
    ]),
    theme('ameixa-noite', 'Ameixa noite', 'escuro', [
        '#381932',
        '#44273E',
        '#FFF3E6',
        '#AB979A',
        '#54384B',
        '#FFC9A8',
        '#111111',
        '#5C3947',
        '#FFC9A8',
    ]),
    theme('indigo-noite', 'Índigo noite', 'escuro', [
        '#282B4A',
        '#353855',
        '#F4F2E8',
        '#A8A8B0',
        '#454760',
        '#EEEBDA',
        '#111111',
        '#4C4E64',
        '#EEEBDA',
    ]),
    theme('floresta-noite', 'Floresta noite', 'escuro', [
        '#062E22',
        '#153B2F',
        '#EEFBE0',
        '#8DA590',
        '#264B3D',
        '#B9F27C',
        '#111111',
        '#265132',
        '#B9F27C',
    ]),
];
export const CLINIC_THEME_KEYS = CLINIC_THEMES.map((row) => row.key);
const hexSchema = z.string().regex(/^#[0-9A-Fa-f]{6}$/);
export const clinicThemeBaseSchema = z.object({
    ground: hexSchema,
    surface: hexSchema,
    ink: hexSchema,
    muted: hexSchema,
    line: hexSchema,
    action: hexSchema,
    on: hexSchema,
    soft: hexSchema,
    brand: hexSchema,
});
/** Tema da clínica: claro e escuro (chave do catálogo ou "logo", com as cores guardadas) e a letra. */
export const clinicThemeSettingsSchema = z
    .object({
    light: z.string().max(40),
    dark: z.string().max(40),
    font: z.enum(CLINIC_THEME_FONTS),
    /** Cores de um tema montado pelo logotipo (chave "logo"). */
    logoLight: clinicThemeBaseSchema.nullable(),
    logoDark: clinicThemeBaseSchema.nullable(),
    /** O tema de antes da última troca, para o Desfazer (vale 7 dias). */
    previous: z
        .object({
        light: z.string().max(40),
        dark: z.string().max(40),
        font: z.enum(CLINIC_THEME_FONTS),
        logoLight: clinicThemeBaseSchema.nullable(),
        logoDark: clinicThemeBaseSchema.nullable(),
    })
        .nullable()
        .optional(),
    changedAt: z.iso.datetime().nullable().optional(),
})
    .refine((value) => (value.light === 'logo'
    ? value.logoLight !== null
    : CLINIC_THEME_KEYS.includes(value.light)) &&
    (value.dark === 'logo' ? value.logoDark !== null : CLINIC_THEME_KEYS.includes(value.dark)), { message: 'Tema desconhecido.' });
export const DEFAULT_CLINIC_THEME = {
    light: 'sec',
    dark: 'escuro',
    font: 'acolhedor',
    logoLight: null,
    logoDark: null,
};
// ── Cor e contraste (WCAG 2.1) ─────────────────────────────────────────────────
const channels = (hex) => [1, 3, 5].map((at) => parseInt(hex.slice(at, at + 2), 16));
const toHex = (values) => `#${values
    .map((value) => Math.round(Math.min(255, Math.max(0, value)))
    .toString(16)
    .padStart(2, '0'))
    .join('')
    .toUpperCase()}`;
export function luminance(hex) {
    const [r, g, b] = channels(hex)
        .map((value) => value / 255)
        .map((value) => (value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4));
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
export function contrast(a, b) {
    const [high, low] = [luminance(a), luminance(b)].sort((x, y) => y - x);
    return (high + 0.05) / (low + 0.05);
}
/** Mistura `a` em `b` na proporção `amount` (0 = só b, 1 = só a). */
export function mix(a, b, amount) {
    const x = channels(a);
    const y = channels(b);
    return toHex(x.map((value, at) => value * amount + y[at] * (1 - amount)));
}
export function alpha(hex, amount) {
    const [r, g, b] = channels(hex);
    return `rgba(${r}, ${g}, ${b}, ${amount})`;
}
const STATUS = {
    claro: { ok: ['#1D7A50', '#E3F4EA'], wait: ['#8A5A06', '#FBF0D6'], bad: ['#B23A2C', '#FBE5E1'] },
    escuro: { ok: ['#5CC493', '#173326'], wait: ['#E6B85C', '#3A2E14'], bad: ['#F08A7C', '#3D1F1A'] },
};
/** Nos temas de vermelho (Vinho, Cereja), o atraso puxa para o laranja e não se confunde com a marca. */
const WARM_BAD = { claro: ['#A8461A', '#FBE9DF'], escuro: ['#F29A6B', '#3D241A'] };
/**
 * As variáveis de CSS do tema: as da mesa (`--mesa-*`) e as gerais que as telas da
 * clínica no celular usam (`--bg`, `--ink`…). Quem aplica põe e tira no `<html>`.
 */
export function clinicThemeVars(base, mode, options = {}) {
    const dark = mode === 'escuro';
    // Cartão sem contorno (T7.29): no claro, o chão fica pelo menos 6% mais escuro que o cartão.
    let ground = base.ground;
    for (let step = 0; !dark && contrast(base.surface, ground) < 1.06 && step < 30; step += 1)
        ground = mix(base.ink, ground, 0.012);
    const status = STATUS[mode];
    const bad = options.warmBad ? WARM_BAD[mode] : status.bad;
    const font = CLINIC_THEME_FONT_INFO[options.font ?? 'acolhedor'];
    const hover = mix(base.ink, base.surface, dark ? 0.06 : 0.035);
    // Letra sobre a tinta (botão escuro no claro, botão claro no escuro).
    const onInk = dark ? ground : '#FFFFFF';
    const vars = {
        '--mesa-bg': ground,
        '--mesa-surface': base.surface,
        '--mesa-line': base.line,
        '--mesa-line-soft': mix(base.line, base.surface, 0.5),
        '--mesa-hover': hover,
        '--mesa-selected': dark ? mix(base.line, base.surface, 0.6) : mix(base.line, ground, 0.45),
        '--mesa-sunken': dark ? mix('#000000', ground, 0.18) : mix(base.ink, ground, 0.025),
        '--mesa-ink': base.ink,
        '--mesa-muted': base.muted,
        '--mesa-faint': mix(base.muted, base.surface, 0.62),
        '--mesa-quiet': mix(base.muted, base.line, 0.25),
        '--mesa-accent': base.action,
        '--mesa-accent-hover': dark
            ? mix('#FFFFFF', base.action, 0.14)
            : mix('#000000', base.action, 0.13),
        '--mesa-accent-soft': base.soft,
        '--mesa-on': base.on,
        '--mesa-on-soft': alpha(base.on, 0.75),
        '--mesa-ok': status.ok[0],
        '--mesa-ok-soft': status.ok[1],
        '--mesa-ok-line': mix(status.ok[0], status.ok[1], 0.28),
        '--mesa-wait': status.wait[0],
        '--mesa-wait-soft': status.wait[1],
        '--mesa-wait-line': mix(status.wait[0], status.wait[1], 0.28),
        '--mesa-bad': bad[0],
        '--mesa-bad-soft': bad[1],
        '--mesa-bad-line': mix(bad[0], bad[1], 0.28),
        '--mesa-bad-stripe': alpha(bad[0], dark ? 0.12 : 0.07),
        '--mesa-glass': alpha(base.surface, 0.7),
        '--mesa-float': dark
            ? '0 12px 32px -14px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.07)'
            : `0 12px 32px -14px ${alpha(base.ink, 0.32)}, 0 0 0 1px ${alpha(base.ink, 0.06)}`,
        // As gerais, para as telas da clínica que não são da mesa.
        '--bg': ground,
        '--surface': base.surface,
        '--s2': base.soft,
        '--ink': base.ink,
        '--ink-2': mix(base.ink, base.muted, 0.5),
        '--muted': base.muted,
        '--faint': mix(base.muted, base.surface, 0.62),
        '--line': base.line,
        '--brand': base.brand,
        '--brandi': base.action,
        '--brand-text': base.action,
        '--good': status.ok[0],
        '--goods': status.ok[1],
        '--danger': bad[0],
        '--on-ink': onInk,
        '--on-ink-soft': alpha(onInk, 0.72),
        '--on-ink-faint': alpha(onInk, 0.18),
        '--on-brand': base.on,
        '--on-danger': dark ? '#111111' : '#FFFFFF',
        '--ok-ink': status.ok[0],
        '--wait-ink': status.wait[0],
        '--wait-soft': status.wait[1],
        '--danger-soft': bad[1],
        '--brand-soft': base.soft,
        '--mute-soft': mix(base.line, base.surface, 0.5),
        '--bar-soft': mix(base.action, base.surface, 0.25),
        '--ink-wash': alpha(base.ink, dark ? 0.06 : 0.04),
        // Cartão: no claro, duas sombras bem leves; no escuro, o cartão é só um tom mais claro.
        '--card-shadow': dark
            ? 'none'
            : `0 1px 2px ${alpha(base.ink, 0.06)}, 0 4px 10px -3px ${alpha(base.ink, 0.08)}, 0 14px 28px -18px ${alpha(base.ink, 0.24)}`,
        '--chip-bg': mix(base.ink, base.surface, dark ? 0.1 : 0.055),
        '--divider': alpha(base.ink, dark ? 0.1 : 0.07),
        '--glass': alpha(base.surface, 0.92),
        '--tone-blue': dark ? '#8AB4FF' : '#1D4ED8',
        '--tone-blue-soft': dark ? '#1C2A44' : '#DBEAFE',
        '--tone-purple': dark ? '#C9A7FF' : '#6D3FB5',
        '--tone-purple-soft': dark ? '#2D2240' : '#EFE4FF',
        '--font-display': font.display,
        '--font-body': font.body,
        '--font-numbers': font.numbers,
        'color-scheme': dark ? 'dark' : 'light',
    };
    return vars;
}
export function clinicThemeByKey(key) {
    return CLINIC_THEMES.find((row) => row.key === key);
}
/**
 * Tema montado a partir de uma cor (a do logotipo): no claro, a cor escurece até passar
 * de 4,5 com letra branca e os neutros puxam o tom dela; no escuro, clareia até passar
 * com letra escura sobre o chão escuro.
 */
export function themeFromColor(hex, mode) {
    if (mode === 'claro') {
        let action = hex.toUpperCase();
        for (let step = 0; contrast(action, '#FFFFFF') < 4.6 && step < 40; step += 1)
            action = mix('#000000', action, 0.06);
        const ground = mix(hex, '#FFFFFF', 0.035);
        const ink = mix(hex, '#141414', 0.18);
        let muted = mix(hex, '#6B6B6B', 0.14);
        for (let step = 0; contrast(muted, '#FFFFFF') < 4.6 && step < 20; step += 1)
            muted = mix('#000000', muted, 0.06);
        return {
            ground,
            surface: '#FFFFFF',
            ink,
            muted,
            line: mix(hex, '#DEDEDE', 0.1),
            action,
            on: '#FFFFFF',
            soft: mix(hex, '#FFFFFF', 0.1),
            brand: hex.toUpperCase(),
        };
    }
    const ground = mix(hex, '#111111', 0.1);
    const surface = mix(hex, '#1E1E1E', 0.12);
    let action = hex.toUpperCase();
    for (let step = 0; contrast(action, surface) < 4.6 && step < 40; step += 1)
        action = mix('#FFFFFF', action, 0.07);
    return {
        ground,
        surface,
        ink: mix(hex, '#EEEEEE', 0.06),
        muted: mix(hex, '#9A9A9A', 0.1),
        line: mix(hex, '#333333', 0.12),
        action,
        on: contrast('#111111', action) >= 4.6 ? '#111111' : '#FFFFFF',
        soft: mix(action, surface, 0.18),
        brand: hex.toUpperCase(),
    };
}
/** Logotipo da clínica: o que existe, as cores lidas e a versão (para o endereço da imagem). */
export const clinicBrandSchema = z.object({
    clinicId: z.uuid(),
    version: z.number().int().min(0),
    claro: z.boolean(),
    escuro: z.boolean(),
    redondo: z.boolean(),
    colors: z.array(z.string().regex(/^#[0-9A-F]{6}$/)).max(3),
});
export const CLINIC_BRAND_KINDS = ['claro', 'escuro', 'redondo'];
